import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {ExamAccessGate} from '../features/attendance/ExamAccessProvider';
import Spinner from './Spinner';
import {signOutWithAudit as signOut} from '../lib/auditLogger';
import { auth } from '../lib/firebase';

const ProtectedRoute = () => {
    const { user, loading, error } = useAuth();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center"><Spinner color="border-purple-500" /></div>;
    }

    if (error) return <div role="alert" className="max-w-lg mx-auto my-20 p-8 bg-white rounded-2xl shadow"><h1 className="text-xl font-bold mb-3">Let’s get you connected</h1><p>{error}</p><button className="mt-6 underline" onClick={() => window.location.reload()}>Try again</button><button className="ml-6 underline" onClick={() => signOut(auth)}>Sign out</button></div>;

    return user ? <ExamAccessGate><Outlet /></ExamAccessGate> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;